module.exports = __webpack_public_path__ + "img/34-green.a1c83aaf.svg";